module.exports = __webpack_public_path__ + "img/user_avatar.d34e072b.png";